export default "__VITE_ASSET__Bxv_gVhd__"